<template>
    <span>
      <span v-if="size === 'small'">
        <v-chip v-if="value === 0" small label class="primary--text" color="#E3F2FD" style="padding:0 0.6rem;">
          一般
        </v-chip>
        <v-chip v-else small label class="warning--text" color="#FFF8E1" style="padding:0 0.6rem;">
          紧急
        </v-chip>
      </span>
      <span v-else>
         <v-chip v-if="value === 0" label class="primary--text" color="#E3F2FD" style="padding:1.1rem 1.2rem;">
          一般
        </v-chip>
        <v-chip v-else label class="warning--text" color="#FFF8E1" style="padding:1.1rem 1.2rem;">
          紧急
        </v-chip>
      </span>
    </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
